import { render, staticRenderFns } from "./ManageEmailSubscriptions.vue?vue&type=template&id=38ef5891&scoped=true&"
import script from "./ManageEmailSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./ManageEmailSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef5891",
  null
  
)

export default component.exports